import { RootState } from 'handlers';
import { getClientTimezone } from 'utils/dateUtils';

export const getLoanOffer = ({ loanOffer }: RootState) => loanOffer;
export const getLoanOfferData = ({ loanOffer }: RootState) => loanOffer.response;

export const getLoanOfferPayload = ({
  nursegridData: { nursegridUserId },
  yourGoal: { loanGoal, aiCoachGoals },
  yourIncome: {
    not_employed: notEmployed,
    total_annual_income: totalAnnualIncome,
    start_of_employment: startOfEmployment,
    employer_name: employerName,
    job_title: jobTitle,
    pay_frequency: payFrequency,
    credential_acquisition_date: credentialsAcquisitionDate,
  },
  yourEmployer: { additionalIncome },
  yourContact: { email, phone_number: phoneNumber },
  yourName: { first_name: firstName, last_name: lastName, credentials },
  professionGroup: { professionGroup },
  preQualificationData: { partnerId, promoCode },
  auth: { sessionToken, hstreamUserInfo: hStreamAuthData },
  applicationStep: { currentFlow },
  cardData: { borrowerCredentials: borrowerCardCredentials },
  yourAddress: { address_line_1: streetAddress, city, zip_code: zipCode, argyle_state: state },
  yourBirthDate: { birth_date: dateOfBirth },
  yourSSN4: { SSN4: last4SSN },
}: RootState) => ({
  nursegridUserId,
  application: {
    professionGroup,
    totalAnnualIncome: totalAnnualIncome ?? 0,
    resumeLink: `${window.location.href}`,
    partnerId,
    loanGoal: loanGoal ?? '[]',
    ...(aiCoachGoals && aiCoachGoals.length > 0 && { aiCoachGoals }),
    credentialsAcquisitionDate,
  },
  borrower: {
    credentials: credentials ?? borrowerCardCredentials,
    streetAddress,
    city,
    zipCode,
    state,
    dateOfBirth,
    firstName,
    lastName,
    phoneNumber,
    email,
    last4SSN,
  },
  notEmployed,
  employment: [
    {
      employerName,
      jobTitle,
      hireDate: startOfEmployment ?? undefined,
      payFrequency,
    },
  ],
  ...(additionalIncome != null && { yourEmployer: { additionalIncome } }),
  timezone: getClientTimezone(),
  currentFlow,
  sessionToken,
  promoCode,
  ...(hStreamAuthData && {
    authData: {
      hStreamAuthData,
    },
  }),
});
